import { useState } from 'react'
import { AxiosUserRepository } from '../../infrastructure/AxiosUserRepository'
import { DeleteUserUseCase } from '../../usecases/DeleteUserByIdUseCase'

const useDeleteUser = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const deleteUser = async (userId: number) => {
        setIsLoading(true)
        setError(null)

        try {
            const repository = new AxiosUserRepository()
            const useCase = new DeleteUserUseCase(repository)

            await useCase.execute(userId)

            return { success: true }
        } catch (err) {
            const errorMessage =
                err instanceof Error
                    ? err.message
                    : 'Error al eliminar el usuario'
            setError(errorMessage)
            return { success: false, error: errorMessage }
        } finally {
            setIsLoading(false)
        }
    }

    return {
        deleteUser,
        isLoading,
        error,
    }
}

export default useDeleteUser
